module.exports = __webpack_public_path__ + "img/icon_instagram_loupe_moins.7d7cab86.svg";